export const useTokenHighlightColor = (
  highlightColor: string | number[] | undefined
) => {
  switch (highlightColor) {
    case "DARK_YELLOW":
      return useRGBToHex([255, 255, 0]);

    case "BLUE":
      return useRGBToHex([0, 0, 255]);

    case "BRIGHT_GREEN":
      return useRGBToHex([0, 255, 0]);

    default:
      // If the highlight color is not an array then return undefined
      if (Array.isArray(highlightColor) != true) return undefined;

      // If the highlight color length is not 3 then it's not an array of RGB values
      if ((highlightColor as any[]).length != 3) return undefined;

      // If the values are not numbers between 0 and 255 then it's not a valid color
      if (
        (highlightColor as any[]).every(
          (value) => typeof value === "number" && value >= 0 && value <= 255
        ) != true
      )
        return undefined;

      return useRGBToHex(highlightColor as number[]);

  }
};
